<template>
  <div class="bank-transfer">
    <div :class="!isPortrait ? 'bank-transfer_main' : false">
      <div class="bank-transfer_title">
        <div v-if="!isPortrait" class="bank-transfer_close" @click.stop="$emit('back')">返回</div>銀行匯款信息
      </div>
      <div class="bank-transfer_info">
        <p class="bank-transfer_info-item" v-for="item in transferInfo" :key="item.id">
          <span class="bank-transfer_info-left">{{item.label}}</span>
          <span class="bank-transfer_info-right">{{item.value}}</span>
        </p>
      </div>
      <div class="refresh-content">
        若您選擇的不是{{userName}}，請刷新頁面
        <div class="refresh-btn j-refresh-btn" @click="refreshPage">刷新</div>
      </div>
      <div class="bank-transfer_tips">注：每次交易由銀行自動生成一個新的儲值賬號。每個儲值賬號只能使用一次。</div>
      <div class="bank-transfer_tips red">若實際匯款金額和儲值金額不符將會導致儲值失敗 ，請牢記匯款金額和匯款帳號。</div>
      <pl-gradient-btn
        class="bank-transfer_btn j-bank-account-dcount"
        @click="getBankAccount"
      >獲取匯款賬號</pl-gradient-btn>
      <div class="bank-transfer_desc">
        <div class="bank-transfer_desc-title">操作說明：</div>
        <div class="bank-transfer_desc-time">
          <p class="bank-transfer_desc-row">1.儲值服務時間：</p>
          <table class="bank-transfer_desc-table">
            <tbody>
              <tr>
                <td class="bank-transfer_desc-tfirst">◇銀行網路匯款儲值轉帳時間</td>
                <td class="bank-transfer_desc-tsecond">24小時</td>
              </tr>
              <tr>
                <td class="bank-transfer_desc-tfirst">◇ATM轉帳儲值轉帳時間</td>
                <td class="bank-transfer_desc-tsecond">24小時</td>
              </tr>
              <tr>
                <td class="bank-transfer_desc-tfirst">◇銀行臨櫃匯款儲值轉帳時間</td>
                <td class="bank-transfer_desc-tsecond">9:00-15:30</td>
              </tr>
              <tr>
                <td class="bank-transfer_desc-tfirst">◇郵局匯款儲值轉帳時間</td>
                <td class="bank-transfer_desc-tsecond">8:00-17:00</td>
              </tr>
            </tbody>
          </table>
          <span
            class="bank-transfer_desc-remit"
          >◇銀行網路匯款儲值、ATM儲值一般15分鐘內到帳，其餘儲值方式的到帳時間為:週一到週四15：30後匯款需隔天到帳，週五15：30後匯款需下週一到帳。</span>
          <p></p>
          <p class="bank-transfer_desc-row">2.為維護自身權益，轉帳完成後請保留匯款單據。</p>
          <p class="bank-transfer_desc-row">3.儲值過程中如果遇到任何問題，請聯繫我們的客服。</p>
          <p class="bank-transfer_desc-row">4.儲值金額將一次性轉為遊戲貨幣，無法分開帳號或同一帳號分多次儲值。</p>
          <p class="bank-transfer_desc-row">5.發票處理方式：</p>
        </div>
        <div class="bank-transfer_desc-invoice">
          <label v-datain="{ext3: '選擇慈善捐贈'}">
            <input
              type="radio"
              name="invoice"
              value="charitable"
              :disabled="disabled"
              v-model="invoiceType"
              class="bank-transfer_desc-radio"
            />
            <span class="bank-transfer_desc-radio">慈善捐贈</span>
          </label>
          <label v-datain="{ext3: '選擇索取發票'}">
            <input
              type="radio"
              name="invoice"
              value="invoice"
              :disabled="disabled"
              v-model="invoiceType"
              class="bank-transfer_desc-radio"
            />
            <span class="bank-transfer_desc-radio">索取發票</span>
          </label>
          <label v-datain="{ext3: '選擇載具發票'}">
            <input
              type="radio"
              name="invoice"
              value="electronic"
              :disabled="disabled"
              v-model="invoiceType"
              class="bank-transfer_desc-radio"
            />
            <span class="bank-transfer_desc-radio">載具發票</span>
          </label>
        </div>
        <div class="bank-transfer_desc-charitable">
          <transition-group name="fade">
            <template v-if="invoiceType==='invoice'">
              <input
                type="text"
                key="bankName"
                v-model="bankName"
                placeholder="銀行帳號"
                class="bank-transfer_desc-input"
              />
              <input
                type="text"
                key="realName"
                v-model="realName"
                placeholder="真實姓名"
                class="bank-transfer_desc-input"
              />
              <input
                type="text"
                key="postAddress"
                v-model="postAddress"
                placeholder="郵寄住址"
                class="bank-transfer_desc-input"
              />
              <input
                type="text"
                key="postArea"
                v-model="postArea"
                placeholder="郵遞區號"
                class="bank-transfer_desc-input"
              />
            </template>
            <template v-if="invoiceType==='electronic'">
              <label class="bank-transfer_desc-label" key="label">
                <span class="bank-transfer_desc-radio">載具選擇：</span>
                <input
                  checked
                  type="radio"
                  style="vertical-align: sub;"
                  class="bank-transfer_desc-radio"
                />
                <span class="bank-transfer_desc-radio">載具發票</span>
              </label>
              <input
                type="text"
                key="mobileCode"
                v-model="mobileCode"
                class="bank-transfer_desc-input"
                placeholder="必須/開頭，只能輸入八碼英數字符號 , 英文需大寫，示例：/0U5B8+P"
              />
              <input
                type="text"
                key="bankAccount"
                v-model="bankAccount"
                placeholder="銀行帳號"
                class="bank-transfer_desc-input"
              />
              <p
                key="tips"
                class="bank-transfer_desc-tips"
              >溫馨提示：載具發票請於儲值當日填寫提交，超過儲值當日請點擊索取發票，填寫可收件地址，我們將把紙本發票郵寄給您</p>
            </template>
          </transition-group>
          <pl-gradient-btn
            @click="confirmMsg"
            class="bank-transfer_desc-btn"
            v-if="invoiceType!=='charitable'"
          >確認</pl-gradient-btn>
          <p class="bank-transfer_desc-row orange-text" style="height: auto;width: 100%">
            1.慈善捐贈：我們會將您的愛心傳遞給財團法人創世社會福利基金會，謝謝您！ 網址：
            <a
              class="animate-site-link"
              href="//www.genesis.org.tw/enter.php"
              target="_blank"
            >http://www.genesis.org.tw/enter.php</a>
          </p>
          <p class="bank-transfer_desc-row orange-text">2.索取發票：我們會郵寄給您發票！</p>
          <div class="bank-transfer_desc-customer" v-show="false">
            <span>客服電話：02-23560356</span>
            <span>工作時間：09:00-17:00</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import viewport from '@/mixins/viewport'
import plGradientBtn from '@/components/pl-gradient-btn'
export default {
  name: 'bank-transfer',
  mixins: [viewport],
  components: { plGradientBtn },
  props: {
    store: {
      type: Object,
      required: true,
      default: () => ({})
    },
    // 是否为竖屏
    isPortrait: {
      type: Boolean,
      default: false
    },
    userName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      transferInfo: [
        {
          id: 1,
          label: '匯款卡號：',
          value: ''
        },
        {
          id: 2,
          label: '銀行代碼：',
          value: '013'
        },
        {
          id: 3,
          label: '匯款面額：',
          value: this.store.realValue || ''
        },
        {
          id: 4,
          label: '銀行名稱：',
          value: '國泰世華銀行-華山分行'
        },
        {
          id: 5,
          label: '銀行戶名：',
          value: '優勢領航科技有限公司'
        }
      ],
      invoiceType: 'charitable',
      bankName: '',
      realName: '',
      postAddress: '',
      postArea: '',
      mobileCode: '',
      bankAccount: '',
      disabled: true
    }
  },
  watch: {
    isPortrait () {
      this.$nextTick(() => {
        this.initViewport()
      })
    }
  },
  methods: {
    showTipsContent (content) {
      this.$store.commit('setTipsState', true)
      this.$store.commit('setTipsContent', content)
    },
    refreshPage () {
      window.location.reload()
    },
    getBankAccount () {
      this.$emit('get-bank-account')
    },
    setBankAccount (account) {
      this.transferInfo.splice(
        0,
        1,
        Object.assign({}, this.transferInfo[0], { value: account })
      )
      this.bankName = account
      this.bankAccount = account
      this.disabled = false
    },
    confirmMsg () {
      let params = {}
      function checkBankAccount (account) {
        if (!/\d{14}/gi.test(account)) {
          this.showTipsContent('銀行賬號格式不正確，請校驗後再次提交')
          return false
        }
        return true
      }
      if (this.invoiceType === 'invoice') {
        if (!this.realName || !this.postAddress || !this.postArea) {
          this.showTipsContent('請填寫完整信息')
          return
        }
        let pass = checkBankAccount(this.bankName)
        if (!pass) return
        params = {
          virtual_account: this.bankName,
          invoice_title: this.realName,
          mail_addr: this.postAddress,
          mail_addr_num: this.postArea
        }
      } else if (this.invoiceType === 'electronic') {
        if (!/^\/.{7}$/.test(this.mobileCode)) {
          this.showTipsContent('請填寫正確載具發票')
          return
        }
        let pass = checkBankAccount(this.bankAccount)
        if (!pass) return
        params = {
          invoice_phone: this.mobileCode,
          virtual_account: this.bankAccount
        }
      }
      this.$datain({ ext3: '提交發票信息' })
      this.$http
        .post(
          '//mstore.gm99.com/virtual_account/get_invoice/',
          qs.stringify(params),
          {
            withCredentials: true,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          }
        )
        .then(res => {
          res = res.data
          if (+res.result === 1) {
            this.showTipsContent('提交成功')
          } else {
            this.showTipsContent(res.msg)
          }
        })
        .catch(err => {
          this.showTipsContent(err.message || '系統錯誤')
        })
    }
  },
  mounted () {
    this.initViewport()
  },
  beforeDestroy () {
    this.removeViewport()
  }
}
</script>

<style lang="scss" scoped>
$themeColor: #e97d30;
$textColor: #6d6d6d;
$tipsColor: #9c9c9c;
.bank-transfer {
  margin-top: 10px;
  padding: 12px 17px;
  box-sizing: border-box;
  background-color: #fff;
  &_main {
    width: 450px;
    margin: 0 auto;
  }
  &_title {
    color: #333;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    position: relative;
  }
  &_close {
    right: 0;
    display: block;
    font-size: 12px;
    cursor: pointer;
    font-weight: 500;
    color: #e97d30;
    padding: 3px 5px;
    border-radius: 5px;
    position: absolute;
    border: 1px solid #e97d30;
  }
  &_info {
    margin-top: 15px;
    &-item {
      margin: 15px 0 0;
    }
    &-left {
      font-size: 13px;
      color: $textColor;
    }
    &-right {
      color: #333;
      font-size: 15px;
      font-weight: 700;
    }
  }
  .refresh-content {
    font-size: 11px;
    padding: 10px 0;
    color: $themeColor;
    .refresh-btn {
      width: 52px;
      height: 22px;
      color: $themeColor;
      line-height: 22px;
      border-radius: 5px;
      text-align: center;
      display: inline-block;
      box-sizing: border-box;
      border: 1px solid $themeColor;
    }
  }
  &_tips {
    font-size: 11px;
    color: $tipsColor;
    &.red {
      color: #f56c6c;
    }
  }
  &_btn {
    margin: 15px auto;
  }
  &_desc {
    &-title {
      font-size: 15px;
      color: $textColor;
    }
    &-table {
      width: 96%;
      margin: 10px auto;
      border-spacing: 0;
      border-collapse: collapse;
      td {
        height: 28px;
        font-size: 11px;
        text-align: left;
        line-height: 28px;
        color: $textColor;
        border: 1px solid #dbdbdb;
      }
      .bank-transfer_desc-tfirst {
        width: 60%;
        padding-left: 5%;
      }
      .bank-transfer_desc-tsecond {
        text-align: center;
      }
    }
    &-remit {
      font-size: 11px;
      color: $tipsColor;
    }
    &-row {
      font-size: 12px;
      color: $textColor;
      &.orange-text {
        color: $themeColor;
      }
    }
    &-invoice {
      display: flex;
      display: table\9;
      width: 100%\9;
      font-size: 12px;
      color: $textColor;
      text-align: center;
      align-items: center;
      justify-content: space-around;
      label {
        display: table-cell\9;
      }
    }
    &-charitable {
      padding-top: 10px;
    }
    &-label {
      font-size: 12px;
      margin-top: 10px;
      padding-left: 2%;
      color: $textColor;
    }
    &-radio {
      display: inline-block;
      vertical-align: middle;
    }
    &-input {
      width: 96%;
      height: 44px;
      outline: none;
      display: block;
      color: $textColor;
      margin: 10px auto;
      padding-left: 10px;
      border-radius: 5px;
      box-sizing: border-box;
      border: 1px solid #c2c2c2;
    }
    &-btn {
      margin: 10px auto;
    }
    &-tips {
      font-size: 11px;
      color: $tipsColor;
    }
    &-customer > span {
      width: 50%;
      font-size: 11px;
      color: $tipsColor;
      text-align: center;
      display: inline-block;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 1, 1);
}

.fade-leave-active {
  display: none;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translate3d(50%, 0, 0);
  transform: translate(50%, 0) \9;
}
</style>
